import styled from "styled-components";

export const VersionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.colors.primary};

  @media (max-width: 600px) {
    gap: 0.5rem; /* Add spacing between logo and text */
  }
`;

export const LogoImage = styled.img`
  width: 8rem;
  height: 2.5rem;
  object-fit: contain;

  @media (max-width: 600px) {
    width: 6rem; /* Smaller logo on mobile */
    height: 2rem;
  }
`;

export const VersionText = styled.span`
  color: ${({ theme }) => theme.colors.background_white};
  white-space: nowrap; /* Prevent text wrapping */
  text-align: right;
  font-size: 1rem; /* Default font size for larger screens */

  @media (max-width: 600px) {
    font-size: 0.65rem; /* Smaller font size on mobile */
  }
`;
